import {
  buildPlanActivationQuestion,
  buildPlanResumeDraftGoalQuestion,
} from "./buildPlanGoalChatQuestion";
import { parseDiagnosisContentSource } from "./parseDiagnosisContentSource";
import { PLAN_DIAGNOSIS_SOURCE } from "./planDiagnosisSource";

export type ResolvePlanResumeDraftMessageParams = {
  draftGoalId: string;
  draftTitle: string;
  summary: string;
  /** Explicit caller hint; takes precedence over parsed diagnosis_content. */
  source?: string;
  /** Raw Goal.diagnosis_content when source is not passed explicitly. */
  diagnosisContent?: string;
};

export function resolvePlanResumeDraftSource(
  params: Pick<
    ResolvePlanResumeDraftMessageParams,
    "source" | "diagnosisContent"
  >,
): string | undefined {
  if (params.source?.trim()) {
    return params.source.trim();
  }

  return parseDiagnosisContentSource(params.diagnosisContent);
}

export function resolvePlanResumeDraftMessage(
  params: ResolvePlanResumeDraftMessageParams,
): string {
  const source = resolvePlanResumeDraftSource(params);

  if (source === PLAN_DIAGNOSIS_SOURCE.ONBOARDING_V3_0_1) {
    return buildPlanActivationQuestion({
      draftGoalId: params.draftGoalId,
      draftTitle: params.draftTitle,
    });
  }

  return buildPlanResumeDraftGoalQuestion({
    draftGoalId: params.draftGoalId,
    draftTitle: params.draftTitle,
    summary: params.summary,
  });
}
